<div class="ui-g-12">
	Search
</div>